import { NgModule } from '@angular/core';
import { BrowserModule, provideClientHydration } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, HttpClientModule, provideHttpClient, withFetch } from '@angular/common/http';  
import { FormsModule } from '@angular/forms';
import { NgOtpInputModule } from 'ng-otp-input'; 
import { MarkdownModule } from 'ngx-markdown';

import { AppRoutingModule } from './app-routing.module';
import { ApiInterceptor } from './interceptors/api.interceptor';
import { AppComponent } from './app.component';
import { IntroAndLogoComponent } from './components/auth/intro-and-logo/intro-and-logo.component';
import { LoginComponent } from './components/auth/login/login.component';
import { AuthComponent } from './components/auth/auth.component';
import { RegisterComponent } from './components/auth/register/register.component';
import { SocialLoginModule, SocialAuthServiceConfig, GoogleLoginProvider } from '@abacritt/angularx-social-login';
import { ForgotPasswordComponent } from './components/auth/forgot-password/forgot-password.component';
import { EnterOtpComponent } from './components/auth/enter-otp/enter-otp.component';
import { ResetPasswordComponent } from './components/auth/reset-password/reset-password.component';
import { SubscriptionPlanComponent } from './components/auth/subscription-plan/subscription-plan.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { CertificatesComponent } from './components/dashboard/certificates/certificates.component';
import { SidebarComponent } from './components/common/sidebar/sidebar.component';
import { NavbarComponent } from './components/dashboard/navbar/navbar.component';
import { CodeSnippetComponent } from './components/dashboard/code-snippet/code-snippet.component';
import { ChatBubbleAiComponent } from './components/dashboard/chat-bubble-ai/chat-bubble-ai.component';
import { ChatBubbleUserComponent } from './components/dashboard/chat-bubble-user/chat-bubble-user.component';
import { SSLChatComponent } from './components/dashboard/ssl-chat/ssl-chat.component';
import { WaveComponentComponent } from './components/dashboard/wave-component/wave-component.component';
import { ToasterComponent } from './components/common/toaster/toaster.component';
import { SuccessComponent } from './components/common/success/success.component';
import { SidebarItemComponent } from './components/common/sidebar-item/sidebar-item.component';
import { MarkdownComponent } from './components/common/markdown/markdown.component';
import { PenComponent } from './components/dashboard/pen/pen.component';
import { LoaderComponent } from './components/common/loader/loader.component';
import { BaseLayoutComponent } from './layouts/base/base.component';
import { GuideListComponent } from './components/guide-list/guide-list.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { PenReportComponent } from './components/pen/pen-report/pen-report.component';
import { PaymentPopupComponent } from "./components/common/payment-popup/payment-popup.component";
import { KeyRotationChatComponent } from './components/dashboard/key-rotation-chat/key-rotation-chat.component';
import { WebsocketTestComponent } from './components/websocket-test/websocket-test.component';
import { DesignPartnerRegisterComponent } from './components/auth/design-partner-register/design-partner-register.component';
import { DesignPartnerLoginComponent } from './components/auth/design-partner-login/design-partner-login.component';
import { TrustComponent } from './components/trust/trust.component';

@NgModule({
  declarations: [
    AppComponent,
    BaseLayoutComponent,
    IntroAndLogoComponent,
    LoginComponent,
    AuthComponent,
    RegisterComponent,
    ForgotPasswordComponent,
    EnterOtpComponent,
    ResetPasswordComponent,
    SubscriptionPlanComponent,
    DashboardComponent,
    CertificatesComponent,
    SidebarComponent,
    NavbarComponent,
    CodeSnippetComponent,
    ChatBubbleAiComponent,
    ChatBubbleUserComponent,
    SSLChatComponent,
    WaveComponentComponent,
    ToasterComponent,
    SuccessComponent,
    SidebarItemComponent,
    MarkdownComponent,
    PenComponent,
    PenReportComponent,
    LoaderComponent,
    GuideListComponent,
    ResetPasswordComponent,
    PaymentPopupComponent,
    KeyRotationChatComponent,
    WebsocketTestComponent,
    DesignPartnerRegisterComponent,
    DesignPartnerLoginComponent,
    TrustComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgOtpInputModule,
    FormsModule,
    HttpClientModule, // Add HttpClientModule
    SocialLoginModule, // Add SocialLoginModule
    MarkdownModule.forRoot(),
    NgApexchartsModule
],
  providers: [
    {
      provide: 'SocialAuthServiceConfig',

      useValue: {
        autoLogin: false,
        providers: [
          {
            id: GoogleLoginProvider.PROVIDER_ID,
            provider: new GoogleLoginProvider(
              '95061866165-f9isitd76vm8bnv1qhelab55mfgv91g2.apps.googleusercontent.com'
            ),
          },
        ],
      } as SocialAuthServiceConfig,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiInterceptor,
      multi: true,
    },
    provideClientHydration(),
    provideHttpClient(withFetch()), // Enable fetch API for HttpClient
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
